// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xlmH","toggle":"styles_toggle__2SdK1","preview":"styles_preview__euQBP"};